import React, { Component} from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Table, {
    TableRow,
    TableCell
} from "@amzn/meridian/table";
import Loader from "@amzn/meridian/loader";
import Link from "@amzn/meridian/link";
import {getContainerHistoryData} from "../../../commons/api/GetContainerHistoryResults.js";
import Text from "@amzn/meridian/text"
import Button from "@amzn/meridian/button";
import chevronLeftLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-left-large";
import chevronRightLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-right-large";
import Icon from "@amzn/meridian/icon";
import Toaster from "@amzn/meridian/toaster"
import Alert from "@amzn/meridian/alert"
import { validateEmail, oldTimeZoneMapper, handleBlankValue } from "../../../commons/CommonUtils.js";
import { FormattedMessage, injectIntl } from "react-intl";

class ContainerHistory extends Component {

    constructor(props) {
        super(props)
        this.state = {
          isLoading : true,
          previousPageTokens: [null],
          nextPageToken: null,
          toasters: []
        }
        this.setUpdated = props.setUpdated.bind(this)
    }

    getPageSize() {
        return 100
    }

    searchPath = "#" + this.props.previousPath + "/";
    
    searchAssociateRequestOption = {
        "type": "ASSOCIATE",
        "startDate": this.props.startDate,
        "endDate": this.props.endDate
    }

    fetchAssociate = (lastProcessedByAssociateName) => {
        return lastProcessedByAssociateName ?
        (validateEmail(lastProcessedByAssociateName) ? 
        (<Link href = {this.searchPath.concat(lastProcessedByAssociateName).concat("/" + JSON.stringify(this.searchAssociateRequestOption))}>{lastProcessedByAssociateName}</Link>)
        : lastProcessedByAssociateName
        )
        : '';
    }

    async nextButtonClick() {
        this.setState({
            isLoading : true,
            toasters: []
        });
        if (this.state.containerHistory.length < this.getPageSize()) {
            this.setState({
                isLoading: false,
                toasters: [{ id: this.props.intl.formatMessage({id: 'search.no_next_entry'}), timeout: 3000}]
            });
        } else {

            let containerHistoryData = await getContainerHistoryData(this.props.containerLabel, this.props.nodeId,
                 this.getPageSize(), this.state.nextPageToken, this.props.startDate, this.props.endDate);
            this.setUpdated({})
            if (containerHistoryData.containerHistory.length > 0) {
                this.setState({
                    isLoading: false,
                    previousPageTokens: this.state.previousPageTokens.concat([this.state.nextPageToken]),
                    containerHistory : containerHistoryData.containerHistory,
                    nextPageToken : containerHistoryData.nextPageToken
                });
            } else {
                this.setState({
                    isLoading: false,
                    toasters: [{ id: this.props.intl.formatMessage({id: 'search.no_next_entry'}), timeout: 3000}]
                });
            }
        }
    }

    async previousButtonClick() {
        this.setState({
            isLoading : true,
            toasters: []
        });

        let newPreviousPageTokens = this.state.previousPageTokens.slice(0, -1);
        let prevPageToken = newPreviousPageTokens.slice(-1).pop();

        let containerHistoryData = await getContainerHistoryData(this.props.containerLabel, this.props.nodeId,
            this.getPageSize(), prevPageToken, this.props.startDate, this.props.endDate);
        this.setUpdated({})

       if (containerHistoryData.containerHistory.length > 0) {
           this.setState({
               isLoading: false,
               previousPageTokens: newPreviousPageTokens,
               containerHistory : containerHistoryData.containerHistory,
               nextPageToken : containerHistoryData.nextPageToken
           });
       } else {
           this.setState({
               isLoading: false,
               toasters: [{ id: this.props.intl.formatMessage({id: 'search.no_previous_entry'}), timeout: 3000}]
           });
       }
    }

    async componentDidMount() {
        let containerHistoryData = await getContainerHistoryData(this.props.containerLabel, this.props.nodeId, this.getPageSize(), null, this.props.startDate, this.props.endDate);
        this.setUpdated({})
        this.setState({
            isLoading : false,
            containerHistory : containerHistoryData.containerHistory ? containerHistoryData.containerHistory : [],
            nextPageToken : containerHistoryData.nextPageToken,
        })
    }

    camel2title(camelCase) {
        if (!camelCase) {
            return camelCase;
        }
        // no side-effects
        return camelCase
          // inject space before the upper case letters
          .replace(/([A-Z])/g, function(match) {
             return " " + match;
          })
          // replace first char with upper case
          .replace(/^./, function(match) {
            return match.toUpperCase();
          });
    }
    
    render() {
        return this.state.isLoading ? <Row spacingInset="large" widths={["grid-2"]}><Column/><Loader/></Row> : this.renderHistoryTable();
    }

    renderHistoryTable() {
        return (
            <React.Fragment>
                <Toaster toasts={this.state.toasters} onCloseToast={() => {this.setState({toasters: []})}} alignmentHorizontal="center">
                    {(toast) => <Alert toast={true}>{toast.id}</Alert>}
                </Toaster>
                <Column spacingInline="large large none large">
                    <Row widths={["grid-12"]} spacingInset="none">
                        <div style={{"overflowX": "scroll"}}>
                            <Table showDividers={false} spacing="small">
                            <TableRow>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.container.history_date" defaultMessage="Date"/></Text></TableCell>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.container.history_operation" defaultMessage="Operation"/></Text></TableCell>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.container.history_associate" defaultMessage="Associate"/></Text></TableCell>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.container.history_parentContainer" defaultMessage="Parent Container"/></Text></TableCell>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.container.history_node" defaultMessage="Node"/></Text></TableCell>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.container.history_location" defaultMessage="Location"/></Text></TableCell>
                            </TableRow>
                            { this.state.containerHistory && this.state.containerHistory.map(history => {
                                let stateChangeTime = new Date(history.stateChangeTime).toLocaleString('en-US', {timeZone: this.props.stationTimeZone? oldTimeZoneMapper(this.props.stationTimeZone) : undefined});
                                return <TableRow>   
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(stateChangeTime)}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(this.camel2title(history.containerState))}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{this.fetchAssociate(handleBlankValue(history.associateName))}</div></TableCell>                              
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(history.parentContainerLabel)}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(history.nodeId)}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(history.location)}</div></TableCell>
                            </TableRow>   
                            })}  
                            </Table>
                        </div>
                    </Row>
                    <Row widths={["grid-6", "grid-6"]} spacingInset="none">
                        <Button type="link" onClick={this.previousButtonClick.bind(this)} disabled={this.state.previousPageTokens.length <= 1}><Icon tokens={chevronLeftLargeTokens} /></Button>
                        <Button type="link" onClick={this.nextButtonClick.bind(this)}><Icon tokens={chevronRightLargeTokens} /></Button>
                    </Row>  
                </Column> 
            </React.Fragment>       
        )
    }
}




export default injectIntl(ContainerHistory);




// WEBPACK FOOTER //
// ./src/components/detailPages/containerDetails/ContainerHistory.js